import React from 'react';
import Styles from './FilterSeparator.module.scss';

export const FilterSeparator = () => <span className={Styles.Separator} />;
